export default {
  checkedCalendars: [],
  calendarList: [],
  selectedCalendarModel: null
}
